import { Button } from '@mui/material';
import { BiFilterAlt } from 'react-icons/bi';

interface ClearFiltersButtonProps {
  onClear: () => void;
  disabled?: boolean;
}

/** The standard Clear Filters control: an outlined utility button, 40px tall like the inputs it follows, last in a filter set. */
const ClearFiltersButton = ({ onClear, disabled = false }: ClearFiltersButtonProps) => (
  <Button
    variant='outlined'
    color='utility'
    startIcon={<BiFilterAlt />}
    onClick={onClear}
    disabled={disabled}
    sx={{ height: 40, whiteSpace: 'nowrap', flexShrink: 0 }}
  >
    Clear Filters
  </Button>
);

export default ClearFiltersButton;
